const ChannelHeader = ({
  logo,
  title,
  subtitle = "Live Sports Channel",
}) => {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-4">
        
        <div className="w-16 h-16 rounded-xl flex items-center justify-center p-2 border border-gray-300 dark:border-gray-700 bg-[#1A1A2E]">
          <img
            src={logo}
            alt={title}
            className="w-full h-full object-contain"
          />
        </div>

        <div>
          <h1 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-blue-500 to-pink-500 bg-clip-text text-transparent">
            {title}
          </h1>

          <p className="text-gray-500 dark:text-gray-400 text-sm">
            {subtitle}
          </p>
        </div>

      </div>
    </div>
  );
};

export default ChannelHeader;